import api from '@/api'
import lamyApi from '@/api/lamy'
import FilterCustomer from '@/components/elements/FilterCustomer'
import config from '@/config'
import moment from 'moment'
import { default as Multiselect, default as multiselect } from 'vue-multiselect'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import CustomerItem from './CustomerItem'
import DateFilter from './../customize/TheNextFaceDateFilter'
import { PAGE } from '@/constants/page.js'

export default {
  data: function () {
    var headers = []

    if (this.$store.state.selectedBot.theme == 'hafele') {
      headers.push({ text: this.$t('ID'), value: 'emp_id' })
    }
    headers.push({ text: '', sortable: false })
    if (this.$store.state.selectedBot.pageid == '100701258941039') {
      headers.push({ text: 'memberid', value: 'memberid' })
      headers.push({ text: 'ชื่อร้านค้า', value: 'shopname' })
      headers.push({ text: 'จังหวัด', value: 'shopprovince' })
    } else if (this.$store.state.selectedBot.type == 'summithr') {
      headers = headers.concat([
        { text: this.$t('name'), value: 'first_name' },
        { text: 'สถานะพนักงาน', value: 'member_status' },
        { text: this.$t('Channel'), value: 'app' },
        { text: this.$t('gender'), value: 'gender' },
        { text: this.$t('Register Date'), value: 'registertimestamp' },
        { text: this.$t('Last Active Date'), value: 'timestamp' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('phone no.'), value: 'phoneno' },
        { text: this.$t('Status'), value: 'status' },
        { text: this.$t('Locale'), value: 'locale' },
        { text: this.$t('Lineid'), value: 'lineid' },
        { text: this.$t('Province'), value: 'province' },
        { text: this.$t('School'), value: 'school' },
        { text: '', sortable: false }
      ])
    } else if (this.$store.state.selectedBot.type == 'nextcapital') {
      headers = headers.concat([
        // { text: '', sortable: false },
        { text: this.$t('name'), value: 'first_name' },
        { text: this.$t('Channel'), value: 'app' },
        { text: this.$t('gender'), value: 'gender' },
        { text: this.$t('next_capital_register_date'), value: 'login_timestamp' },
        { text: this.$t('Register Date'), value: 'registertimestamp' },
        { text: this.$t('Last Active Date'), value: 'timestamp' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('phone no.'), value: 'phoneno' },
        { text: this.$t('Status'), value: 'status' },
        { text: this.$t('Locale'), value: 'locale' },
        { text: this.$t('Lineid'), value: 'lineid' },
        { text: this.$t('Province'), value: 'province' },
        { text: this.$t('School'), value: 'school' },
        { text: '', sortable: false }
      ])
    } else if (['veranda_new', 'verso'].includes(this.$store.state.selectedBot.theme)) {
      headers = headers.concat([
        { text: this.$t('name'), value: 'first_name' },
        { text: this.$t('Channel'), value: 'app' },
        { text: this.$t('gender'), value: 'gender' },
        { text: this.$t('Register Date'), value: 'registertimestamp' },
        { text: this.$t('Last Active Date'), value: 'timestamp' },
        { text: this.$t('satisfaction_score'), value: 'satisfaction_score' },
        { text: this.$t('feedback'), value: 'feedback' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('phone no.'), value: 'phoneno' },
        { text: this.$t('Status'), value: 'status' },
        { text: this.$t('Locale'), value: 'locale' },
        { text: this.$t('Lineid'), value: 'lineid' },
        { text: this.$t('Province'), value: 'province' },
        { text: this.$t('School'), value: 'school' },
        { text: '', sortable: false }
      ])
    } else if (['root'].includes(this.$store.state.selectedBot.type)) {
      headers = headers.concat([
        { text: this.$t('name'), value: 'first_name' },
        { text: this.$t('Channel'), value: 'app' },
        { text: this.$t('gender'), value: 'gender' },
        { text: this.$t('Register Date'), value: 'registertimestamp' },
        { text: this.$t('Last Active Date'), value: 'timestamp' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('phone no.'), value: 'phoneno' },
        { text: this.$t('Company Name'), value: 'company_name' },
        { text: this.$t('Locale'), value: 'locale' },
        { text: this.$t('Lineid'), value: 'lineid' },
        { text: this.$t('Province'), value: 'province' },
        { text: this.$t('School'), value: 'school' },
        { text: '', sortable: false }
      ])
    } else if (['jamsai'].includes(this.$store.state.selectedBot.type)) {
      headers = headers.concat([
        // { text: '', sortable: false },
        { text: this.$t('name'), value: 'first_name' },
        { text: 'Jamsai Id', value: 'room_id' },
        { text: this.$t('Channel'), value: 'app' },
        { text: this.$t('gender'), value: 'gender' },
        { text: this.$t('Register Date'), value: 'registertimestamp' },
        { text: this.$t('Last Active Date'), value: 'timestamp' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('phone no.'), value: 'phoneno' },
        { text: this.$t('Status'), value: 'status' },
        { text: this.$t('Locale'), value: 'locale' },
        { text: this.$t('Lineid'), value: 'lineid' },
        { text: this.$t('Province'), value: 'province' },
        { text: this.$t('School'), value: 'school' },
        { text: '', sortable: false }
      ])
    } else if (PAGE.DDPROPERTY.includes(this.$store.state.selectedBot.pageid)) {
      headers = headers.concat([
        // { text: '', sortable: false },
        { text: this.$t('name'), value: 'first_name' },
        { text: this.$t('Channel'), value: 'app' },
        { text: this.$t('gender'), value: 'gender' },
        { text: this.$t('Register Date'), value: 'registertimestamp' },
        { text: this.$t('Last Active Date'), value: 'timestamp' },
        { text: this.$t('เวลาจบสนทนา (sec)'), sortable: false },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('phone no.'), value: 'phoneno' },
        { text: this.$t('Status'), value: 'status' },
        { text: this.$t('Locale'), value: 'locale' },
        { text: this.$t('Lineid'), value: 'lineid' },
        { text: this.$t('Province'), value: 'province' },
        { text: this.$t('School'), value: 'school' },
        { text: '', sortable: false }
      ])
    } else if (['aira'].includes(this.$store.state.selectedBot.theme)) {
      headers = headers.concat([
        // { text: '', sortable: false },
        { text: this.$t('name'), value: 'first_name' },
        { text: this.$t('Aira id'), value: 'aira_id' },
        { text: this.$t('Channel'), value: 'app' },
        { text: this.$t('gender'), value: 'gender' },
        { text: this.$t('Register Date'), value: 'registertimestamp' },
        { text: this.$t('Last Active Date'), value: 'timestamp' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('phone no.'), value: 'phoneno' },
        { text: this.$t('Status'), value: 'status' },
        { text: this.$t('Locale'), value: 'locale' },
        { text: this.$t('Lineid'), value: 'lineid' },
        { text: this.$t('Province'), value: 'province' },
        { text: this.$t('School'), value: 'school' },
        { text: '', sortable: false }
      ])
    } else {
      headers = headers.concat([
        // { text: '', sortable: false },
        { text: this.$t('name'), value: 'first_name' },
        { text: this.$t('Channel'), value: 'app' },
        { text: this.$t('gender'), value: 'gender' },
        { text: this.$t('Register Date'), value: 'registertimestamp' },
        { text: this.$t('Last Active Date'), value: 'timestamp' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('phone no.'), value: 'phoneno' },
        { text: this.$t('Status'), value: 'status' },
        { text: this.$t('Locale'), value: 'locale' },
        { text: this.$t('Lineid'), value: 'lineid' },
        { text: this.$t('Province'), value: 'province' },
        { text: this.$t('School'), value: 'school' },
        { text: '', sortable: false }
      ])
    }

    return {
      selectedCom7page: {
        pageid: null,
        name: ''
      },
      headers: headers,
      pageNumber: 1,
      pagination: { rowsPerPage: -1, sortBy: '' },
      tag: '',
      singleStatus: '',
      showAdvance: false,
      users: [],
      limit: 100,
      offset: 0,
      hasNext: true,
      count: 0,
      gendercount: '',
      users_count: [],
      intents: [],
      delayImport: false,
      search: '',
      filter: undefined,
      loading: true,
      errorFilterTag: [],
      pagetmp: 1,
      errorFilterStatus: [],
      customerfromfb: null,
      total_user: '',
      exportlimit: 5000,
      showExport: false,
      exportpagecount: 0,
      exportType: null,
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm'),
        end: moment().format('YYYY-MM-DD HH:mm')
      },
      createCustomAudienceDialog: false,
      customAudienceName: null,

      historyCustomAudiencePage: false,
      filterTcpPage: ''
    }
  },
  components: {
    ScaleLoader,
    CustomerItem,
    PulseLoader,
    Multiselect,
    FilterCustomer,
    multiselect,
    DateFilter
  },
  mounted: async function () {
    this.initFilter()

    if (['studio7', 'ticket2'].includes(this.selectedBot.theme)) {
      let com7page = this.$store.state.com7pages.find((f) => f.pageid == this.selectedBot.pageid)
      this.selectedCom7page.name = com7page.name
    }

    if (this.isTcpMainPage && !this.$store.state.tcpSubpages) {
      this.$store.dispatch('getTcpSubpages')
    }

    this.initCustomer()

    if (this.isLamy) {
      this.getLamyProductMasterData()
    }
  },
  computed: {
    isDDProperty() {
      if (this.selectedBot) {
        if (PAGE.DDPROPERTY.includes(this.selectedBot.pageid)) {
          return true
        }
      }
      return false
    },
    pagelength() {
      if (this.total_user) {
        return Math.ceil(this.total_user / 100)
      } else {
        return 1
      }
    },
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    isLamy() {
      return [...this.$store.state.lamyPage].includes(this.selectedBot.pageid)
    },
    usersFormat() {
      if (this.users && this.users.length) {
        let temp = []
        this.users.forEach((ele) => {
          let obj = ele
          try {
            obj.json_variable = obj.json_variable ? JSON.parse(obj.json_variable) : {}
          } catch (error) {
            obj.json_variable = {}
            console.error(error)
          }
          obj.memberid =
            obj.json_variable && obj.json_variable.memberid ? obj.json_variable.memberid : ''
          temp.push(obj)
        })
        return temp
      } else {
        return []
      }
    },
    filteredHeader() {
      Array.prototype.insert = function (index) {
        index = Math.min(index, this.length)
        arguments.length > 1 &&
          this.splice.apply(this, [index, 0].concat([].pop.call(arguments))) &&
          this.insert.apply(this, arguments)
        return this
      }
      if (PAGE.OCEAN_PSYJAI.includes(this.selectedBot.pageid)) {
        return [
          { text: '', sortable: false },
          { text: this.$t('name'), value: 'first_name' },
          { text: this.$t('Channel'), value: 'app' },
          { text: this.$t('gender'), value: 'gender' },
          { text: this.$t('Register Date'), value: 'registertimestamp' },
          { text: this.$t('Last Active Date'), value: 'timestamp' },
          { text: this.$t('Email'), value: 'email' },
          { text: this.$t('phone no.'), value: 'phoneno' },
          { text: this.$t('Status'), value: 'status' },
          { text: 'Consent', value: 'consent' },
          { text: '', sortable: false }
        ]
      }

      if (this.isBU) return this.headers
      else if (this.$store.state.niveapage.includes(this.selectedBot.pageid)) {
        return [
          { text: '', sortable: false },
          { text: this.$t('name'), value: 'first_name' },
          { text: this.$t('Channel'), value: 'app' },
          { text: this.$t('gender'), value: 'gender' },
          { text: this.$t('Message Sent'), value: 'usermessages' },
          { text: this.$t('Register Date'), value: 'registertimestamp' },
          { text: this.$t('Last Active Date'), value: 'timestamp' },
          { text: this.$t('Email'), value: 'email' },
          { text: this.$t('phone no.'), value: 'phoneno' },
          { text: this.$t('Status'), value: 'status' },
          { text: this.$t('Locale'), value: 'locale' },
          { text: '', sortable: false }
        ]
      } else if (this.$store.state.lamyPage.includes(this.selectedBot.pageid)) {
        return [
          { text: '', sortable: false },
          { text: this.$t('Name'), value: 'first_name' },
          { text: this.$t('Channel'), value: 'app' },
          { text: this.$t('Register Date'), value: 'registertimestamp' },
          { text: this.$t('Last Active Date'), value: 'timestamp' },
          { text: this.$t('level'), value: 'member_type' },
          { text: this.$t('total_purchase'), value: 'total_purchase' },
          { text: this.$t('Tag'), value: 'tag' },
          { text: this.$t('member_status'), value: 'member_status' }
        ]
      } else if (this.selectedBot.theme == 'scgdistribution') {
        return this.headers
          .filter((v) => {
            return !['lineid', 'province', 'school'].includes(v.value)
          })
          .insert(2, [
            {
              text: this.$t('Shop code'),
              value: 'cardnumber',
              align: 'left',
              width: 'auto'
            },
            {
              text: this.$t('Shop name'),
              value: 'realname',
              align: 'left',
              width: 'auto'
            },
            {
              text: this.$t('Province'),
              value: 'province',
              align: 'left',
              width: 'auto'
            }
          ])
      } else if (this.isRatchthani) {
        const tempHeader = this.headers
        const item = [{ text: 'ชื่อที่ตั้งค่า', value: 'realname' }]
        tempHeader.splice(2, 0, ...item)
        return tempHeader
      } else if (this.isDelta) {
        const tempHeader = this.headers
        const item = [
          { text: 'Warranty Registration', value: 'warranty_registration' },
          { text: 'Showroom Registration', value: 'showroom_registration' }
        ]
        tempHeader.splice(2, 0, ...item)
        return tempHeader
      } else {
        if (this.isFacebookConversionConnected) {
          return [
            ...this.headers.filter((v, index) => {
              return (
                (!['lineid', 'province', 'school'].includes(v.value) && v.text !== '') ||
                index === 0
              )
            }),
            { text: this.$t('order_quantity'), value: 'event_quantity', align: 'center' },
            { text: this.$t('total_purchase_amount'), value: 'event_value' },
            { text: this.$t('first_time_purchase_2'), value: 'event_created_at' },
            { text: this.$t('latest_purchase'), value: 'event_last_updated_at' },
            { text: '', sortable: false }
          ]
        }

        return this.headers.filter((v) => {
          return !['lineid', 'province', 'school'].includes(v.value)
        })
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
      computedImportDelay: 'getDelayCustomerImport',
      isFacebookConversionConnected: 'isFacebookConversionConnected'
    }),
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    },
    filterIntent: function () {
      var vm = this
      vm.intents.sort(function (a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      var intents =
        vm.intents && vm.intents.length > 0 ? vm.intents.map((intent) => intent.intentname) : []
      return intents
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            result = tags.map((tag) => ({ text: tag }))
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      }
    },
    status: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.status && vm.filter.status !== '') {
          var status = []
          status = vm.filter.status.split(',')
          var result = []
          if (status) {
            result = status.map((s) => ({ text: s }))
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          result = value.map((s) => s.text)
        }
        vm.filter.status = result.join(',')
      }
    },
    tcpPageOptions() {
      return this.$store.state.tcpSubpages || []
    },
    isTcpMainPage() {
      return PAGE.TCP_MAIN_PAGE.includes(this.selectedBot.pageid)
    },
    isTcpSubpage() {
      return PAGE.TCP_SHOP_SERVICES.includes(this.selectedBot.pageid)
    },
    isRatchthani() {
      return PAGE.RATCHTHANI.includes(this.selectedBot.pageid)
    },
    isDelta() {
      return PAGE.DELTA.includes(this.selectedBot.pageid)
    },
    isOceanPsyjai() {
      return PAGE.OCEAN_PSYJAI.includes(this.selectedBot.pageid)
    }
  },
  methods: {
    initFilter() {
      this.filter = {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        status: '',
        tags: '',
        tagtype: 'includes',
        lineid: '',
        school: '',
        province: '',
        uu_register_status: '',
        specialcondition: '',
        statustype: 'includes',
        member_status: '',
        lamySendNotiMember: false,
        lamyDaySendNoti: '',
        lamy_member_type: '',
        lamy_interested_product_type: '',
        lamy_total_purchase_from: '',
        lamy_total_purchase_to: '',
        lamy_total_product_purchase_from: '',
        lamy_total_product_purchase_to: '',
        lamy_product_category: '',
        lamy_product_model: '',
        lamy_product_name: '',
        lamy_product_size: '',
        lamy_product_head_type: '',
        lamy_product_colour: '',
        jamsai_id: '',
        ...(this.isFacebookConversionConnected && {
          filter_event_data_value: {},
          filter_event_data_quantity: {},
          filter_event_data_time: {}
        })
      }
    },
    async updateCustomAudience(audience_id, user_ids) {
      var data = {
        pageid: this.selectedBot.pageid,
        audience_id: audience_id,
        body: { user_ids: user_ids }
      }
      var response = await api.updateCustomAudience(data)
      if (response.success) {
        return response
      }
    },
    async createCustomAudience() {
      var vm = this
      try {
        if (this.users && this.users.length > 0) {
          for (let i = 0; i < vm.users.length; i += 10000) {
            const chunk = vm.users
              ? vm.users
                  .filter((user) => {
                    return user.app == 'facebook'
                  })
                  .slice(i, i + 10000)
                  .map((user) => {
                    return user.id
                  })
              : []
            if (i < 10000) {
              var data = {
                pageid: vm.selectedBot.pageid,
                body: { user_ids: chunk, custom_audience_name: 'ZWIZ_' + vm.customAudienceName }
              }
              vm.$store.dispatch('loading')
              vm.createCustomAudienceDialog = false
              var response = await api.createCustomAudience(data)
              vm.customAudienceName = ''
              if (response && response.success && vm.users.length <= 10000) {
                vm.$swal.fire({
                  title: vm.$t('Successfully'),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm'),
                  reverseButtons: true
                })
                vm.$store.dispatch('loading')
              } else {
                vm.$store.dispatch('loading')
                vm.createCustomAudienceDialog = false
                if (vm.users.length <= 10000) {
                  vm.$swal.fire({
                    title: vm.$t('error'),
                    text: `${response.response.data.result.error.message} : ${response.response.data.result.error.error_user_msg}`,
                    type: 'error',
                    confirmButtonText: vm.$t('Confirm'),
                    reverseButtons: true
                  })
                }
              }
            } else {
              var responseUpdate = await vm.updateCustomAudience(response.result.audience_id, chunk)
              if (
                responseUpdate &&
                responseUpdate.success &&
                vm.users.length === i + responseUpdate.result.num_received
              ) {
                vm.$store.dispatch('loading')
                vm.$swal.fire({
                  title: vm.$t('Successfully'),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm'),
                  reverseButtons: true
                })
              }
            }
          }
        } else {
          this.$swal.fire({
            title: 'เพจของคุณยังไม่มีลูกค้าเก่า',
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            reverseButtons: true
          })
        }
      } catch (error) {
        console.error(error)
        this.$store.dispatch('loading')
        this.createCustomAudienceDialog = false
        if (this.users.length <= 10000) {
          this.$swal.fire({
            title: this.$t('error'),
            text: error.message,
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            reverseButtons: true
          })
        }
      }
    },
    async initCustomer() {
      var vm = this
      vm.getIntent()
      vm.$store.dispatch('loadStatus')
    },
    onCountdownEnd() {
      this.$store.commit('REMOVE_DELAY_IMPORT', {
        pageid: this.selectedBot.pageid
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * 100 - 100
        this.getMoreCustomers()
      }
    },
    estimateReach: function (data) {
      var vm = this

      vm.loadingEstimate = true
      api.estimateReach(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.loadingEstimate = false
          return
        }
        if (response.data) {
          vm.total_user = response.data.total
        }
        vm.loadingEstimate = false
      })
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 20) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function (newTags) {
      this.tags = newTags
    },
    checkStatus(obj) {
      this.errorFilterStatus = []
      if (obj.tag.text.length > 20) {
        this.errorFilterStatus.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterStatus.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addStatus: function (newTags) {
      this.status = newTags
    },
    clearSearch: function () {
      this.initFilter()
      this.$forceUpdate()

      this.onSearch()
    },
    onSearch: function () {
      var vm = this
      vm.$validator.validate().then(async (result) => {
        if (!result) {
          vm.goToErrorInput()
          return false
        }
        vm.offset = 0
        vm.hasNext = true
        vm.users = []
        vm.loading = true
        try {
          const users = await vm.getLoadUsers(vm.limit, vm.offset)
          vm.users = vm.users.concat(users)
        } catch (error) {
          console.error(error)
        }
        vm.loading = false
      })
    },
    collectexportcustomersanalytic() {
      var vm = this
      let data = {
        pageid: vm.pageid,
        grouptype: vm.grouptype,
        filter: vm.filter,
        limit: vm.limit,
        offset: vm.offset
      }

      api.putcollectexportcustomersanalytic(data, function (error) {
        if (error) {
          console.error(error)

          return
        }
      })
    },
    getLoadUsers: function (limit, offset) {
      const vm = this
      return new Promise((resolve, reject) => {
        const { sortBy, descending } = this.pagination
        let data = {
          pageid: vm.pageid,
          grouptype: vm.grouptype,
          // opt_in: vm.filter
          filter: vm.filter,
          limit: limit,
          offset: offset,
          statustype: vm.filter.statustype,
          sortBy: sortBy,
          descending: descending,
          opt_in: vm.filter && vm.filter.opt_in ? vm.filter.opt_in : null
        }

        if (vm.selectedBot.type == 'summithr') {
          data.member_status = vm.filter.member_status
        }
        if (vm.selectedBot.type == 'jamsai') {
          data.jamsai_id = vm.filter.jamsai_id
        }

        if (vm.$store.state.selectedBot.pageid == '100701258941039') {
          data.registertimestamp_from = vm.selectedDate.start
          data.registertimestamp_to = vm.selectedDate.end
        }

        if (vm.isLamy) {
          if (vm.filter.lamySendNotiMember) {
            Object.assign(data, {
              lamy_member_expired_status: vm.filter.lamySendNotiMember,
              lamy_member_expired_day: vm.filter.lamyDaySendNoti
            })
          } else {
            Object.assign(data, {
              lamy_member_expired_status: vm.filter.lamySendNotiMember
            })
          }

          if (vm.filter.lamy_member_type) {
            const tempData = vm.filter.lamy_member_type.map((el) => {
              return el.value
            })
            Object.assign(data, {
              lamy_member_type: tempData.toString()
            })
          }

          if (vm.filter.lamy_interested_product_type) {
            Object.assign(data, {
              lamy_interested_product_type: vm.filter.lamy_interested_product_type
            })
          }

          if (vm.filter.lamy_total_purchase_from) {
            Object.assign(data, {
              lamy_total_purchase_from: vm.filter.lamy_total_purchase_from
            })
          }

          if (vm.filter.lamy_total_purchase_to) {
            Object.assign(data, {
              lamy_total_purchase_to: vm.filter.lamy_total_purchase_to
            })
          }

          if (vm.filter.lamy_total_product_purchase_from) {
            Object.assign(data, {
              lamy_total_product_purchase_from: vm.filter.lamy_total_product_purchase_from
            })
          }

          if (vm.filter.lamy_total_product_purchase_to) {
            Object.assign(data, {
              lamy_total_product_purchase_to: vm.filter.lamy_total_product_purchase_to
            })
          }

          if (vm.filter.lamy_product_category) {
            if (vm.filter.lamy_product_category.length > 0) {
              const tempData = vm.filter.lamy_product_category.toString()
              Object.assign(data, {
                lamy_product_category: tempData
              })
            }
          }

          if (vm.filter.lamy_product_model) {
            if (vm.filter.lamy_product_model.length > 0) {
              const tempData = vm.filter.lamy_product_model.toString()
              Object.assign(data, {
                lamy_product_model: tempData
              })
            }
          }

          if (vm.filter.lamy_product_name) {
            if (vm.filter.lamy_product_name.length > 0) {
              const tempData = vm.filter.lamy_product_name.toString()
              Object.assign(data, {
                lamy_product_name: tempData
              })
            }
          }

          if (vm.filter.lamy_product_size) {
            if (vm.filter.lamy_product_size.length > 0) {
              const tempData = vm.filter.lamy_product_size.toString()
              Object.assign(data, {
                lamy_product_size: tempData
              })
            }
          }

          if (vm.filter.lamy_product_head_type) {
            if (vm.filter.lamy_product_head_type.length > 0) {
              const tempData = vm.filter.lamy_product_head_type.toString()
              Object.assign(data, {
                lamy_product_head_type: tempData
              })
            }
          }

          if (vm.filter.lamy_product_colour) {
            if (vm.filter.lamy_product_colour.length > 0) {
              const tempData = vm.filter.lamy_product_colour.toString()
              Object.assign(data, {
                lamy_product_colour: tempData
              })
            }
          }
        }

        if (vm.isTcpMainPage) {
          data.pageid = vm.filterTcpPage ? vm.filterTcpPage.page_id : vm.selectedBot.pageid
          Object.assign(data, {
            tcp_master_page_id: vm.selectedBot.pageid
          })
        }

        if (PAGE.JORAKAY.includes(vm.$store.state.selectedBot.pageid)) {
          data.sortBy = 'timestamp'
          data.descending = true
        }

        var selectedApi = 'getAllUsers'
        if (['ticket2', 'studio7'].includes(this.$store.state.selectedBot.theme)) {
          selectedApi = 'getcom7getallusers'
          data.pageid = this.selectedCom7page.pageid
            ? this.selectedCom7page.pageid
            : this.selectedBot.pageid
        }
        api[selectedApi](data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (vm.limit > response.data.length) {
            vm.hasNext = false
          }

          var users = response.data
          users = users.map(function (user) {
            return {
              ...user,
              phoneno: vm.setPhoneForMtcUser(user.phoneno, user.id),
              consent: 'Accept'
            }
          })
          vm.total_user = response.count
          resolve(users)
        })
      })
    },
    setPhoneForMtcUser(phone, id) {
      if (this.selectedBot && ['mtc'].includes(this.selectedBot.type) && !phone) {
        return id
      } else {
        return phone
      }
    },
    async handleFetchCustomers() {
      const vm = this
      vm.loading = true
      try {
        const users = await vm.getLoadUsers(vm.limit, 0)
        vm.users = users
      } catch (error) {
        console.error(error)
      }
      vm.loading = false
    },
    async getMoreCustomers() {
      var vm = this
      vm.loading = true
      try {
        const users = await vm.getLoadUsers(vm.limit, vm.offset)
        vm.users = users
      } catch (error) {
        console.error(error)
      }
      vm.loading = false
    },
    onFailLoad: function (index) {
      this.$set(this.users[index], 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    onActiveStartDate: function (value) {
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
    },
    onActiveEndDate: function (value) {
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
    },
    onRegisterStartDate: function (value) {
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
    },
    onRegisterEndDate: function (value) {
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
    },
    getIntent: function (callback) {
      let vm = this
      let data = {
        pageid: vm.pageid
      }
      var selectedApi = 'getIntent'
      if (['ticket2', 'studio7'].includes(this.$store.state.selectedBot.theme)) {
        selectedApi = 'getcom7intents'
        data.pageid = this.selectedCom7page.pageid
          ? this.selectedCom7page.pageid
          : this.selectedBot.pageid
      }
      api[selectedApi](data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          vm.intents = response.data.map((intent) => {
            return {
              ...intent,
              isShow: false
            }
          })
        }
        if (callback) {
          callback()
        }
      })
    },

    async exportDataSummary(offset) {
      let vm = this
      var limit = 5000
      vm.loading = true

      var users = await vm.getLoadUsers(limit, offset)
      var json = []
      if (typeof users !== 'undefined') {
        users.map((item) => {
          var userid =
            vm.$store.getters.getPackage == 'premium'
              ? item.id
                ? item.id
                : '-'
              : this.$t('premium')
          var userid_split = null
          try {
            userid_split = item.app == 'line' ? userid.split('__')[0] : userid
          } catch (error) {
            userid_split = userid
          }
          var userData = {
            ...(vm.selectedBot.theme === 'tcp'
              ? {
                  Page: vm.filterTcpPage ? vm.filterTcpPage.page_name : vm.selectedBot.pagename
                }
              : {}),
            pageuid: userid_split,
            'Social Name':
              (item.first_name ? item.first_name : '') +
              ' ' +
              (item.last_name ? item.last_name : ''),
            'E-mail': item.email,
            Phone: item.phoneno
          }
          if (item.session) {
            let tempData = ''
            try {
              tempData = JSON.parse(item.session)
            } catch (error) {
              tempData = item.session
            }
            Object.assign(userData, tempData)
          }
          json.push(userData)
        })
        const dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'zwiz-data-summary.csv')
        vm.loading = false
      }
      vm.collectexportcustomersanalytic()
    },

    exportCustomer: function (offset = 0) {
      const vm = this

      let limit = 5000
      vm.loading = true

      vm.getLoadUsers(limit, offset).then(
        function (users) {
          if (users && users.length > 0) {
            var json = []

            let deltaAllSubscribeList = []
            if (vm.isDelta) {
              users.forEach((val) => {
                let tagList = val.tags.split(',')
                tagList.forEach((tag) => {
                  if (tag.toLowerCase().startsWith('subscribe_')) {
                    deltaAllSubscribeList.push(tag)
                  }
                })
              })
            }
            deltaAllSubscribeList = [...new Set(deltaAllSubscribeList)]
            users.forEach(function (val) {
              let userData = null
              let locale = config.locale.find(function (locale) {
                if (val.locale == locale.value) {
                  return true
                }
              })
              var userid =
                vm.$store.getters.getPackage == 'premium'
                  ? val.id
                    ? val.id
                    : '-'
                  : vm.$t('premium')
              var userid_split = null
              try {
                userid_split = val.app == 'line' ? userid.split('__')[0] : userid
              } catch (error) {
                userid_split = userid
              }
              var tempJson = val.json_variable ? JSON.parse(val.json_variable) : {}
              var memberid = tempJson && tempJson.memberId ? tempJson.memberId : ''

              const registerTimestamp = val.registertimestamp
                ? vm.getFormatDate(
                    val.registertimestamp,
                    vm.isDDProperty ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'
                  )
                : '-'
              const lastTimestamp = val.timestamp
                ? vm.getFormatDate(
                    val.timestamp,
                    vm.isDDProperty ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'
                  )
                : '-'
              const diffTimestamp = vm.getTimeDiff(val.registertimestamp, val.timestamp)
              if (vm.selectedBot.type == 'nextcapital') {
                userData = {
                  memberid,
                  pageuid: userid_split,
                  'Emloployee ID': val.employee_id,
                  ...(vm.selectedBot.theme == 'scgdistribution'
                    ? {
                        [vm.$t('Shop code')]: val.cardnumber,
                        [vm.$t('Shop name')]: val.realname,
                        [vm.$t('Province')]: val.address
                      }
                    : {}),
                  'Social Name':
                    (val.first_name ? val.first_name : '') +
                    ' ' +
                    (val.last_name ? val.last_name : ''),
                  Channel: val.app,
                  Gender: val.gender,
                  'Next Capital Register Date': val.login_timestamp
                    ? moment(val.login_timestamp).format('DD/MM/YYYY')
                    : '-',
                  'Register Date': val.registertimestamp
                    ? moment(val.registertimestamp).format('DD/MM/YYYY')
                    : '-',
                  'Last Active Date': val.timestamp
                    ? moment(val.timestamp).format('DD/MM/YYYY')
                    : '-',
                  Email:
                    vm.$store.getters.getPackage == 'premium'
                      ? val.email
                        ? val.email
                        : ''
                      : vm.$t('premium'),
                  Address: val.address,
                  'Phone No':
                    vm.$store.getters.getPackage == 'premium' ? val.phoneno : vm.$t('premium'),
                  Status: vm.$store.getters.getPackage == 'premium' ? val.status : vm.$t('premium'),
                  Tag: vm.$store.getters.getPackage == 'premium' ? val.tags : vm.$t('premium'),
                  Locale: locale ? locale : ''
                }
              } else if (vm.selectedBot.type == 'jamsai') {
                userData = {
                  memberid,
                  pageuid: userid_split,
                  'Emloployee ID': val.employee_id,
                  ...(vm.selectedBot.theme == 'scgdistribution'
                    ? {
                        [vm.$t('Shop code')]: val.cardnumber,
                        [vm.$t('Shop name')]: val.realname,
                        [vm.$t('Province')]: val.address
                      }
                    : {}),
                  'Social Name':
                    (val.first_name ? val.first_name : '') +
                    ' ' +
                    (val.last_name ? val.last_name : ''),
                  Channel: val.app,
                  Gender: val.gender,
                  'Register Date': val.registertimestamp
                    ? moment(val.registertimestamp).format('DD/MM/YYYY')
                    : '-',
                  'Last Active Date': val.timestamp
                    ? moment(val.timestamp).format('DD/MM/YYYY')
                    : '-',
                  ...(['veranda_new', 'verso'].includes(vm.selectedBot.theme)
                    ? {
                        [vm.$t('satisfaction_score')]: vm.handleGetSatisfactionData(
                          val.feedback,
                          'score'
                        ),
                        [vm.$t('feedback')]: vm.handleGetSatisfactionData(val.feedback, 'feedback')
                      }
                    : {}),
                  Email:
                    vm.$store.getters.getPackage == 'premium'
                      ? val.email
                        ? val.email
                        : ''
                      : vm.$t('premium'),
                  Address: val.address,
                  'Phone No':
                    vm.$store.getters.getPackage == 'premium' ? val.phoneno : vm.$t('premium'),
                  Status: vm.$store.getters.getPackage == 'premium' ? val.status : vm.$t('premium'),
                  Tag: vm.$store.getters.getPackage == 'premium' ? val.tags : vm.$t('premium'),
                  Locale: locale ? locale : '',
                  'Jamsai ID': val.roomid
                }
              } else if (vm.isDelta) {
                let tagList = val.tags.split(',')
                let subscribeList = {}
                deltaAllSubscribeList.forEach((allSubscribe) => {
                  subscribeList[allSubscribe] = '-'
                  tagList.forEach((tag) => {
                    if (tag.toLowerCase().startsWith('subscribe_')) {
                      if (allSubscribe == tag) {
                        subscribeList[allSubscribe] = tag
                      }
                    }
                  })
                })
                let session = {}
                try {
                  session = JSON.parse(val.session)
                } catch (error) {
                  //
                }
                userData = {
                  pageuid: userid_split,
                  'Social Name':
                    (val.first_name ? val.first_name : '') +
                    ' ' +
                    (val.last_name ? val.last_name : ''),
                  'Wanranty Registration': val.warranty_status ? 'Registered' : '-',
                  'Showroom Registration': val.booking_status ? 'Booked' : '-',
                  Channel: val.app,
                  Gender: val.gender,
                  'Register Date': registerTimestamp,
                  'Last Active Date': lastTimestamp,
                  Email:
                    vm.$store.getters.getPackage == 'premium'
                      ? val.email
                        ? val.email
                        : ''
                      : vm.$t('premium'),
                  Address: val.address,
                  'Phone No':
                    vm.$store.getters.getPackage == 'premium' ? val.phoneno : vm.$t('premium'),
                  Status: vm.$store.getters.getPackage == 'premium' ? val.status : vm.$t('premium'),
                  Tag: vm.$store.getters.getPackage == 'premium' ? val.tags : vm.$t('premium'),
                  ...subscribeList,
                  สรุปข้อมูล: session && session.name_info ? session.name_info : '-'
                }
              } else if (PAGE.OCEAN_PSYJAI.includes(vm.selectedBot.pageid)) {
                userData = {
                  pageuid: userid_split,
                  'Social Name':
                    (val.first_name ? val.first_name : '') +
                    ' ' +
                    (val.last_name ? val.last_name : ''),
                  Channel: val.app,
                  ...(vm.selectedBot.theme === 'tcp'
                    ? {
                        Page: vm.filterTcpPage
                          ? vm.filterTcpPage.page_name
                          : vm.selectedBot.pagename
                      }
                    : {}),
                  Gender: val.gender,
                  'Register Date': registerTimestamp,
                  'Last Active Date': lastTimestamp,
                  Email:
                    vm.$store.getters.getPackage == 'premium'
                      ? val.email
                        ? val.email
                        : ''
                      : vm.$t('premium'),
                  'Phone No':
                    vm.$store.getters.getPackage == 'premium' ? val.phoneno : vm.$t('premium'),
                  Status: vm.$store.getters.getPackage == 'premium' ? val.status : vm.$t('premium'),
                  Tag: vm.$store.getters.getPackage == 'premium' ? val.tags : vm.$t('premium'),
                  Consent: 'Accept'
                }
              } else {
                const tempSession = val.session ? JSON.parse(val.session) : {}
                const arrSession = []
                Object.keys(tempSession).forEach((key) => {
                  arrSession.push(`${key}: ${tempSession[key]}`)
                })

                userData = {
                  pageuid: userid_split,
                  ...(vm.selectedBot.theme == 'aira'
                    ? {
                        'Aira id': val.aira_id || '-'
                      }
                    : {}),

                  ...(vm.selectedBot.theme == 'scgdistribution'
                    ? {
                        [vm.$t('Shop code')]: val.cardnumber,
                        [vm.$t('Shop name')]: val.realname,
                        [vm.$t('Province')]: val.address
                      }
                    : {}),
                  'Social Name':
                    (val.first_name ? val.first_name : '') +
                    ' ' +
                    (val.last_name ? val.last_name : ''),
                  ...(vm.isRatchthani
                    ? {
                        ชื่อที่ตั้งค่า: val.realname
                      }
                    : {}),
                  Channel: val.app,
                  ...(vm.selectedBot.theme === 'tcp'
                    ? {
                        Page: vm.filterTcpPage
                          ? vm.filterTcpPage.page_name
                          : vm.selectedBot.pagename
                      }
                    : {}),
                  Gender: val.gender,
                  'Register Date': registerTimestamp,
                  'Last Active Date': lastTimestamp,
                  ...(vm.isDDProperty ? { 'เวลาจบสนทนา (sec)': diffTimestamp } : {}),
                  ...(['veranda_new', 'verso'].includes(vm.selectedBot.theme)
                    ? {
                        [vm.$t('satisfaction_score')]: vm.handleGetSatisfactionData(
                          val.feedback,
                          'score'
                        ),
                        [vm.$t('feedback')]: vm.handleGetSatisfactionData(val.feedback, 'feedback')
                      }
                    : {}),
                  Email:
                    vm.$store.getters.getPackage == 'premium'
                      ? val.email
                        ? val.email
                        : ''
                      : vm.$t('premium'),
                  Address: val.address,
                  'Phone No':
                    vm.$store.getters.getPackage == 'premium' ? val.phoneno : vm.$t('premium'),
                  Status: vm.$store.getters.getPackage == 'premium' ? val.status : vm.$t('premium'),
                  Tag: vm.$store.getters.getPackage == 'premium' ? val.tags : vm.$t('premium'),
                  Locale: locale ? locale : '',
                  ...(['skf'].includes(vm.selectedBot.type) && {
                    Session: arrSession.length > 0 ? arrSession.join(', ') : '-'
                  }),
                  ...(vm.isFacebookConversionConnected && {
                    'Order Quantity': val.event_quantity || '-',
                    'Total Purchase Amount': val.event_value
                      ? [val.event_value, val.event_currency].join(' ').trim()
                      : '-',
                    'First Time Purchase': val.event_created_at
                      ? moment(val.event_created_at).format('DD/MM/YYYY')
                      : '-',
                    'Latest Purchase': val.event_last_updated_at
                      ? moment(val.event_last_updated_at).format('DD/MM/YYYY')
                      : '-'
                  })
                }
              }
              if (
                vm.selectedBot.pageid == '105911105134578' ||
                vm.selectedBot.pageid == '101931352240400' ||
                vm.selectedBot.type == 'hopinnhr' ||
                vm.$store.state.pageListSingGaling.includes(vm.selectedBot.pageid)
              ) {
                // the next face demo
                let obj = ''
                try {
                  userData.userid = val.id.toString()
                  obj = JSON.parse(val.session)
                  delete obj.ep
                  userData.savesession = obj && Object.keys(obj).length ? JSON.stringify(obj) : ''
                } catch (error) {
                  userData.savesession = ''
                }
              }
              if (vm.selectedBot.theme === 'my_allianz') {
                Object.assign(userData, {
                  ...(val.my_allianz_member_data && {
                    'My Allianz Login': String(!!val.my_allianz_member_data.is_login),
                    'OA - Refkey My Allianz':
                      (val.my_allianz_member_data.oa_ref_key || []).join(', ') || '',
                    'My Allianz Login Timestamp': val.my_allianz_member_data.registered_timestamp
                      ? moment(val.my_allianz_member_data.registered_timestamp).format(
                          'DD/MM/YYYY HH:mm'
                        )
                      : ''
                  }),
                  ...(val.health_living_member_data && {
                    'Healthy Living Login': String(!!val.health_living_member_data.is_login),
                    'OA - Refkey Healthy Living':
                      (val.health_living_member_data.oa_ref_key || []).join(', ') ||
                      val.health_living_member_data.healthy_living_user_id ||
                      '',
                    'Healthy Living Login Timestamp': val.health_living_member_data
                      .registered_timestamp
                      ? moment(val.health_living_member_data.registered_timestamp).format(
                          'DD/MM/YYYY HH:mm'
                        )
                      : ''
                  }),
                  ...(val.aagi_member_data && {
                    'AAGI Login': String(!!val.aagi_member_data.is_login),
                    'OA - Refkey AAGI': (val.aagi_member_data.oa_ref_key || []).join(', ') || '',
                    'AAGI Login Timestamp': val.aagi_member_data.registered_timestamp
                      ? moment(val.aagi_member_data.registered_timestamp).format('DD/MM/YYYY HH:mm')
                      : ''
                  })
                })
              }
              if (userData) json.push(userData)
            })

            // vm.exportCsv(csvContent, 'zwiz-customer-' + offset)
            const dataWS = XLSX.utils.json_to_sheet(json)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, dataWS)
            XLSX.writeFile(wb, 'zwiz-customer.csv')
            vm.loading = false
          } else {
            vm.loading = false
          }
        },
        function () {
          vm.loading = false
        }
      )
      vm.collectexportcustomersanalytic()
    },
    getTimeDiff(registerTimestamp, lastTimestamp) {
      const registertimestamp = moment(registerTimestamp)
      const timestamp = moment(lastTimestamp)
      const seconds = timestamp.diff(registertimestamp, 'seconds')
      return seconds > 0 ? seconds : 0
    },
    onExportCustomer(type) {
      this.exportType = type
      this.exportpagecount = Math.ceil(this.total_user / this.exportlimit)

      if (this.exportpagecount > 1) {
        this.showExport = true
      } else {
        if (this.exportType === 'dataSummary') {
          this.exportDataSummary(0)
        } else {
          this.exportCustomer(0)
        }
      }
    },
    importCustomer: function () {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to import customer?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            var data = {
              pageid: vm.selectedBot.pageid
            }
            vm.loading = true
            vm.offset = 0
            vm.hasNext = true
            vm.users = []
            api.insertUsersFromInbox(data, async function (error, response) {
              if (error) {
                vm.loading = false
                return
              }
              if (response.responsecode == 200) {
                api.insertUsersFromDone(data, function (error) {
                  if (error) {
                    console.error(error)
                  }
                  vm.getLoadUsers(vm.limit, vm.offset).then(
                    function (users) {
                      vm.users = vm.users.concat(users)
                      vm.delayImport = true
                      var time = moment().add(1, 'hours').format('YYYY-MM-DD HH:mm:ss')
                      vm.$store.commit('SET_DELAY_IMPORT', {
                        pageid: vm.selectedBot.pageid,
                        time: time
                      })
                      vm.$swal.fire({
                        title: vm.$t('Import customer successful'),
                        type: 'success',
                        confirmButtonText: vm.$t('Confirm'),
                        cancelButtonText: vm.$t('cancel'),
                        reverseButtons: true
                      })
                      vm.loading = false
                    },
                    function (error) {
                      console.error(error)
                      vm.loading = false
                    }
                  )
                })
              }
            })
          }
        })
    },
    async getLamyProductMasterData() {
      const vm = this
      try {
        const data = {
          pageId: vm.selectedBot.pageid
        }
        const response = await lamyApi.getFilterProductMasterData({ config: data })
        if (response && response.status === 200) {
          vm.$store.state.lamyFilterProductMasterData = response.data.filter
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    handleGetSatisfactionData(value, column) {
      if (value) {
        const splitData = value.split('-')
        const score = splitData[0] || '-'
        const feedback = splitData[1] || '-'

        return column === 'score' ? score : column === 'feedback' ? feedback : '-'
      } else {
        return '-'
      }
    }
  },
  watch: {
    pagination: {
      async handler() {
        this.loading = true
        try {
          this.users = await this.getLoadUsers(this.limit, this.offset)
        } catch (error) {
          console.error(error)
        }
        this.loading = false
      },
      deep: true
    },
    count: function (newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$emit('onUserLoaded', vm.count)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/dashboard/customer/Customers.js